import { getDateFromDateInTimeZone } from '@jbhi-fi/utils/src/date/getDateFromDateInTimeZone';
import { format } from 'date-fns-tz';
import { enAU } from 'date-fns/locale/en-AU';
import { enNZ } from 'date-fns/locale/en-NZ';

export const getSalesLineHours = () => {
  // The values for sales line hours are entered in Melbourne or Auckland time
  const timeZone = (() => {
    switch (window.Jbhifi.storeLocation) {
      case 'AU':
        return {
          name: 'Australia/Melbourne',
          locale: enAU,
        };
      case 'NZ':
        return {
          name: 'Pacific/Auckland',
          locale: enNZ,
        };
    }
  })();

  const now = new Date();
  const dayOfWeek = now.getDay();
  const hours = (window.Jbhifi.jbSalesLineHours?.[dayOfWeek] ?? [])
    .map(timeString => timeString.trim().padStart(4, '0'))
    .map(timeString => {
      return { hour: parseInt(timeString.slice(0, 2), 10), minute: parseInt(timeString.slice(2, 4), 10) };
    })
    .map(({ hour }) => getDateFromDateInTimeZone({ hour, timeZone: timeZone.name }))
    .filter(datetime => !!datetime)
    .map(datetime =>
      Intl.DateTimeFormat('en-AU', { hour: 'numeric', hourCycle: 'h12' }).format(datetime).replace(' ', '')
    );

  if (hours.length !== 2) return undefined;

  const userTimezone = format(now, 'zzz', { locale: timeZone.locale });

  return `${hours[0]} – ${hours[1]} (${userTimezone})`;
};
